import { api } from "../ModuloGerenciador/UrlPadrao";

export const getHome = async ({ token, id }) => {
  return api.get("home?usuarioId=" + id, {
    headers: {
      Authorization: token,
    },
  });
};
